export const environment = {
  production: true,
  api: {
    account: 'https://api.truckr.io/accounts/v1/',
    carrier: 'https://api.truckr.io/carrier/',
  },
  portal: {
    account: 'https://accounts.truckerally.com/'
  },
  keys: {
    stripe: 'pk_live_3JWRuXuCvNPUuH0J6WHV2Lrk0045aynPgy'
  },
  analytics: {
    id: 'G-2LD4NNWTX5'
  },
};

